<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :persistenceKey="persistenceKey"
    :gcPopupCustomerProductHistoryDtlConfig="
      gcPopupCustomerProductHistoryDtlConfig
    "
    :setLoading="setLoading"
    :loadDataGrid="loaded"
    :rowClick="rowClickCallBack"
    :ref="'product-history-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "../../_mixins/data-grid.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  CustomerTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/customer-tabs";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { getFilteredValueByKey } from "../../_helpers/templates/transaction-list";
import { CommonStorage } from "../../_services/storage";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      gcPopupCustomerProductHistoryDtlConfig: {},
      setLoading: false,
      loaded: false,
      CustomerSalesRepresentativeCode: undefined,
      persistenceKey: "product-history-list",
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Customers",
        selectedIndex: GetIndexByTabName("Product History"),
        tabs: CustomerTabs,
        exportFileName: "Customer Product History",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProductHistoryList",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "DiscountPcnt",
                "FXCurrency",
                "InvoiceNo",
                "MovementDate",
                "PriceGroupId",
                "PriceGroupShortDescription",
                "ProductCode",
                "ProductDescription1",
                "SalesOrder",
                "SalesUM",
                "SalesUMQty",
                "SalesUMStandardCost",
                "UnitPriceBase",
                "UnitPriceFX",
                "CustomerCode",
                "CustomerName",
                "ExTotalBase",
                "TaxBase",
                "IncTotalBase",
                "ExTotalFX",
                "TaxFX",
                "IncTotalFX",
                "SalesUMStandardPriceBase",
                "SalesUMStandardPriceFX",
                "GrossProfitPcnt",
                "GrossProfitBase",
              ],
              keyType: {
                Attribute01: "Guid",
                Attribute02: "Guid",
                Attribute03: "Guid",
                Attribute04: "Guid",
                Attribute05: "Guid",
                Attribute06: "Guid",
                Attribute07: "Guid",
                Attribute08: "Guid",
                Attribute09: "Guid",
                Attribute10: "Guid",
                Attribute11: "Guid",
                Attribute12: "Guid",
                Attribute13: "Guid",
                Attribute14: "Guid",
                Attribute15: "Guid",
                Attribute16: "Guid",
                Attribute17: "Guid",
                Attribute18: "Guid",
                Attribute19: "Guid",
                Attribute20: "Guid",
              },
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No customer product history found",
                message: "Get Started, Add a Product History",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            filterOnEnter: true,
          },
          columns: this.getColumns,
        },
      };

      return config;
    },
    getColumns() {
      return [
        {
          screenField: "Product",
          filterIndex: 1,
        },
        {
          screenField: "Date",
          sortOrder: "desc",
          dataField: "MovementDate",
          label: "Date",
        },
        {
          screenField: "Invoice",
          dataField: "InvoiceNo",
          label: "Invoice #",
          filterIndex: 2,
          filterDataField: "InvoiceNo",
          filterLabel: "Invoice #",
          type: "Integer",
          hyperlink: {
            url: `invoice/review/__ID__`,
            dataField: "InvoiceNo",
            target: "_blank",
          },
          width: ColumnWidth.InvoiceNumber.width,
          minWidth: ColumnWidth.InvoiceNumber.minWidth,
        },
        {
          screenField: "Invoice",
          label: "Sales Order #",
          dataField: "SalesOrder",
          filterLabel: "Sales Order #",
          filterIndex: 3,
          filterDataField: "SalesOrder",
          type: "Integer",
          width: ColumnWidth.SalesOrderNumber.width,
          minWidth: ColumnWidth.SalesOrderNumber.minWidth,
          hyperlink: {
            url: `sales-order/review/__ID__`,
            dataField: "SalesOrder",
            target: "_blank",
          },
        },
        {
          screenField: "Customer",
          filterIndex: 1,
        },
        {
          dataField: "FXCurrency",
          label: "Currency",
          minWidth: ColumnWidth.CurrencyCode.minWidth,
          width: ColumnWidth.CurrencyCode.width,
        },
        {
          screenField: "SalesUM",
          label: "Sales UM",
          dataField: "SalesUM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          width: ColumnWidth.UnitOfMeasure.width,
        },
        {
          screenField: "SalesUMQty",
          dataField: "SalesUMQty",
          label: "Sales UM Qty",
          minWidth: ColumnWidth.Quantity.minWidth,
          width: ColumnWidth.Quantity.width,
        },
        {
          dataField: "SalesUMStandardCost",
          label: "Sales UM Std Cost (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "SalesUMStandardPriceBase",
          label: "Sales UM Std Price (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "SalesUMStandardPriceFX",
          label: "Sales UM Std Price (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "UnitPriceFX",
          label: "Sales UM Price (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "UnitPriceBase",
          label: "Sales UM Price (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          screenField: "DiscountPercent",
          label: "Disc",
          dataField: "DiscountPcnt",
          visible: false,
          showInColumnChooser: true,
        },
        {
          dataField: "ExTotalFX",
          label: "Ex Total (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "TaxFX",
          label: "Tax (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "IncTotalFX",
          label: "Inc Total (FX)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "ExTotalBase",
          label: "Ex Total (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "TaxBase",
          label: "Tax (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "IncTotalBase",
          label: "Inc Total (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
          visible: false,
        },
        {
          dataField: "GrossProfitPcnt",
          label: "GP %",
          type: "Decimal",
          format: "Decimal-16-2P",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          dataField: "GrossProfitBase",
          label: "GP (Base Currency)",
          type: "Decimal",
          format: "Decimal-16-2",
          minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
          width: ColumnWidth.Price2DecimalPoints.width,
        },
        {
          screenField: "PriceGroup",
          gridDataField: "PriceGroupId",
          cellTemplateRecord: {
            primary: [
              {
                dataField: "PriceGroupShortDescription",
              },
            ],
            secondary: [
              {
                dataField: "PriceGroupId",
              },
            ],
          },
          exportFields: [
            {
              dataField: "PriceGroupId",
              label: "Price Group Code",
            },
            {
              dataField: "PriceGroupShortDescription",
              label: "Price Group Description",
            },
          ],
        },

        // Filter only columns
        {
          screenField: "CustomerGroup",
          filterLabel: "Customer Group",
          filterDataField: "CustomerGroup",
          filterIndex: 4,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "CustomerType",
          filterLabel: "Customer Type",
          filterDataField: "CustomerType",
          filterIndex: 5,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "Market",
          filterLabel: "Customer Market",
          filterDataField: "CustomerMarket",
          filterIndex: 6,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "Region",
          filterLabel: "Customer Region",
          filterDataField: "CustomerRegionCode",
          filterIndex: 7,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "SubRegion",
          filterLabel: "Customer Sub Region",
          filterDataField: "CustomerSubregionCode",
          filterIndex: 8,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "ProductCategory1",
          filterLabel: "Product Category 1",
          filterDataField: "ProductCategory1",
          filterIndex: 9,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "ProductCategory2",
          filterLabel: "Product Category 2",
          filterDataField: "ProductCategory2",
          filterIndex: 10,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "ProductCategory3",
          filterLabel: "Product Category 3",
          filterDataField: "ProductCategory3",
          filterIndex: 11,
          visible: false,
          showInColumnChooser: false,
        },
        {
          screenField: "ProductCategory4",
          filterLabel: "Product Category 4",
          filterDataField: "ProductCategory4",
          filterIndex: 12,
          visible: false,
          showInColumnChooser: false,
        },
        // {
        //   screenField: "GridRecordEllipsisMenu",
        //   select: false,
        //   allowSearch: false,
        //   cssClass: "padding-7",
        //   ellipsisMenu: {
        //     itemAction: (data) => {
        //       var items = [
        //         {
        //           menuText: "Product History Detail",
        //           data: data,
        //           clickAction: this.showCustomerProductHistoryDetail,
        //         },
        //       ];
        //       return items;
        //     },
        //     keyExpr: "menuText",
        //     displayExpr: "menuText",
        //   },
        // },
      ].concat(this.getAttributeColumns(12, false, false));
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    navigateToDestination(e) {
      this.$router.push({
        path: `customer`,
      });
    },
    showCustomerProductHistoryDetail(e) {
      let columns = [];
      if (CommonStorage.getItems(this.persistenceKey)) {
        columns = JSON.parse(
          CommonStorage.getItems(this.persistenceKey),
        ).columns;
      }

      const filterData = getFilteredValueByKey(
        this.$refs,
        "product-history-list",
      );

      this.gcPopupCustomerProductHistoryDtlConfig = {
        visible: true,
        hidden: () => {
          this.gcPopupCustomerProductHistoryDtlConfig.visible = false;
        },
        dataModel: e,
        columns: columns,
        filters: filterData,
      };
    },

    rowClickCallBack(e) {
      if (e.rowType == "data" && e.column.screenField != "Invoice") {
        const data = e.data;
        this.showCustomerProductHistoryDetail(data);
      }
    },
  },

  async created() {
    this.setLoading = true;
    this.loaded = true;
  },
};
</script>

<style lang="scss">
.dx-datagrid
  .dx-datagrid-content
  .dx-datagrid-table
  .dx-row
  > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
  vertical-align: top !important;
}
</style>
